import SmoothScrollbars from '@rio-cloud/rio-uikit/components/smoothScrollbars/SmoothScrollbars';
import Fade from '@rio-cloud/rio-uikit/Fade';
import { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { DEFAULT_ROUTE, TOUR_SETTINGS_ROUTE } from '../../common/constants';
import { PageNavigationBar } from '../../components/PageNavigationBar/PageNavigationBar';
import { config } from '../../configuration/config';
import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import { RouteOptions } from '../../containers/RouteOptions/RouteOptions';
import { selectPageDisplayed } from '../../store/app/appSelectors';
import { updatePage } from '../../store/app/appSlice';

export const TourSettingsPage = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const hasInitialized = useRef(false);

    const pageDisplayed = useAppSelector(selectPageDisplayed);
    const showContent = pageDisplayed === TOUR_SETTINGS_ROUTE;

    useEffect(() => {
        if (!hasInitialized.current && pageDisplayed !== TOUR_SETTINGS_ROUTE) {
            dispatch(updatePage(TOUR_SETTINGS_ROUTE));
        }
        hasInitialized.current = true;
    }, [dispatch, pageDisplayed]);

    const handleExitNav = useCallback(() => {
        navigate(DEFAULT_ROUTE, { replace: false });
    }, [navigate]);

    const handleClickGoBackNav = useCallback(() => {
        dispatch(updatePage(DEFAULT_ROUTE));
    }, [dispatch]);

    return (
        <Fade initial animationStyle={Fade.PAGE_BACK} show={showContent} onExitComplete={handleExitNav}>
            <div className='display-flex flex-column height-100vh' data-testid='tour-settings-page'>
                <div data-testid='summary-back-button'>
                    <PageNavigationBar
                        title='intl-msg:smartRoute.generic.tourSettings'
                        navBack={handleClickGoBackNav}
                    />
                </div>
                <SmoothScrollbars>
                    <div className='display-flex flex-column padding-x-15 padding-top-15' data-testid='tour-settings'>
                        <RouteOptions />
                    </div>
                    <div className='position-absolute bottom-0 text-size-12 text-color-light text-right padding-x-15'>
                        {config.app_version}
                    </div>
                </SmoothScrollbars>
            </div>
        </Fade>
    );
};
